import style from './style.module.scss';
import {useEffect, useState} from "react";

interface PopupProps {
    title: string;
    message: string;
    isShown: boolean;
    action: () => void;
}

export const Popup: React.FC<PopupProps> = ({title, message, isShown,action}) => {

    const [showPopup, setShowPopup] = useState(true);

    useEffect(() => {
        setShowPopup(isShown);
    }, [isShown])

    const closePopup = () => {
        setShowPopup(!showPopup);
        action();
    }

    return (
        <>
            {showPopup && (
                <div className={`${style.overlay} ${showPopup ? style.show : ''}`}>
                    <div className={`${style.popup} ${showPopup ? style.show : ''}`} id="popup">
                        <h2>{title}</h2>
                        <p>{message}</p>
                        <button type="button" onClick={closePopup}>OK</button>
                    </div>
                </div>
            )}
        </>
    )
}